export default {
  default: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/layouts/default.vue").then(m => m.default || m),
  extended: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/layouts/extended.vue").then(m => m.default || m)
}